import { Trans } from 'react-i18next';
import type { Mode } from '../../../../types';
import { useGetDateTitle } from '../../hooks';
import type { ButtonDirection } from '../DateNavigator';
import { useGetShiftedDate } from './useGetShiftedDate';

export const Translation = ({
  date,
  direction,
  i18nKey,
  mode,
}: {
  date: Date;
  direction: ButtonDirection;
  i18nKey: string;
  mode: Mode;
}) => {
  const getTitleText = useGetDateTitle();
  const getShiftedDate = useGetShiftedDate();

  return (
    <Trans
      components={{ br: <br /> }}
      i18nKey={i18nKey}
      values={{ date: getTitleText({ date: getShiftedDate({ date, direction, mode }), hideWeekNumber: true }) }}
    />
  );
};
